import { h, Component } from 'preact';
import pure from 'utils/pure';
import s from 'components/pages/showtimes/cities.sss';
import { joinClasses } from 'utils/utils';
import { track } from 'utils/tracking';
import Store from 'store/store';
import * as actions from 'store/actions';
import { SvgSearch } from 'components/shared/svgIcons/svgIcons';
import { Link } from 'components/core/link/link.js';
import removeDiacritics from 'utils/removeDiacritics';
import HTML from 'components/core/html/html';

export default @pure class Cities extends Component {

	constructor() {
		super();
		this.renderCity = this.renderCity.bind(this);
		this.showMoreCities = this.showMoreCities.bind(this);
		this.showMoreKeyDown = this.showMoreKeyDown.bind(this);
	}

	getCities() {
		const { cities, clientGeo, searchRadius = 1 } = this.props;
		let currentCity = clientGeo && removeDiacritics((clientGeo.city || '').toLowerCase());
		let searchRadiusFinal = searchRadius * 10;
		return cities.filter(c => {
			if (removeDiacritics((c.name || '').toLowerCase()) === currentCity) return false;
			return c.distanceKm >= searchRadiusFinal;
		}).sort((a, b) => a.distanceKm - b.distanceKm);
	}

	selectCity(city, event) {
		if (event && event.preventDefault) {
			// stop the page from refreshing
			event.preventDefault();
		}

		Store.emit(actions.RESET_FILTERS);
		Store.emit(actions.SET_CLIENT_GEO, city.geo);
		// For easier use in pixels
		Store.emit(actions.SELECT_NEARBY_CITY, city.geo);
		track({ a: 'nearby_location_selected', l: 'from city list', useCustomPageTrack: true });
	}

	showMoreCities() {
		let newCount = (this.props.cityShowCount || 10) + 10;
		Store.emit(actions.SET_CITY_SHOW_COUNT, newCount);
		track({ a: 'show_more_locations', l: newCount, useCustomPageTrack: true });
	}

	showMoreKeyDown(e) {
		if (e.key === 'Enter') {
			this.showMoreCities();
		}
	}

	renderCity(city) {
		const {
			distance, // (number) distance between the user and the city
			distanceUnit, // (string) unit of measurement that the above distance is calculated in
		} = city;

		let display = city.name;
		if (this.props.showState && city.state && city.geo.countryCode === 'us') {
			display += ', ' + city.state;
		}

		return (
			<li class={s.city}>
				<Link
					queryString={{ location: city.name }}
					ignoreExitModal
					extraOnClick={this.selectCity.bind(this, city)}
					renderCustomChild
					trackId="city_click" // redundant but at least it's not an unknown link out
					trackLabel={city.name}
				>
					<SvgSearch class={s.icon} />
					<div class={s.content}>
						<span class={s.name}>{display}</span>
						{distance < 1000 && <span class={s.distance}>{distance.toFixed(1) + distanceUnit}</span>}
					</div>
				</Link>
			</li>
		);
	}

	renderMore(totalCities) {
		let cityShowCount = this.props.cityShowCount || 10;
		let hidden = cityShowCount >= this.props.cities.length || totalCities <= cityShowCount;
		let copy = this.props.copy;
		let topClass = joinClasses(s.more, hidden && s.hidden);
		// TODO move the + inside the copy
		let name = <span class={s.name}>+{copy.$MORE}</span>;

		if (this.props.moreLinkOut) {
			// TODO preserve part of the query string ?
			// e.g. keep campaign but get rid of showbarebones and iframe
			return (
				<Link key="more" href="?" target="_blank" class={topClass} renderCustomChild>
					{name}
				</Link>
			);
		}
		return (
			<li
				class={topClass}
				key="more"
				onClick={this.showMoreCities}
				tabindex="0"
				role="button"
				onKeyDown={this.showMoreKeyDown}
			>
				{name}
			</li>
		);
	}

	render({ cities, copy, loading, cityShowCount = 10 }) {
		if (loading) {
			return <div />;
		}

		cities = cities || [];
		if (cities.toJS) cities = cities.toJS();
		// TODO: update displayedCities when cities change, not in render

		const totalCities = this.getCities().length;
		const displayedCities = this.getCities().slice(0, cityShowCount);

		if (!displayedCities.length) {
			return <div />;
		}

		return (
			<div class={s.cities}>
				{copy.$MORE_SHOWTIMES_FOUND_IN && <HTML tag="h3" content={copy.$MORE_SHOWTIMES_FOUND_IN} markdown />}
				<ul key="list">
					{displayedCities.map(this.renderCity)}
					{this.renderMore(totalCities)}
				</ul>
				{copy.$MORE_SHOWTIMES_FOUND_IN && <HTML tag="h3" content={copy.$MORE_SHOWTIMES_AFTER_TEXT} markdown />}
			</div>
		);
	}
}
